import { GS_ROLE } from 'utils/constants'
import { AdminSettings } from 'gen/rtk-openapi'

/**
 * returns the default policy for a given role as defined by Greenspark
 * by default some roles will have access to certain modules and not others but the yard admin can always tweak how they want
 * @param gsRole
 */
const getGsDefaultPolicy = (gsRole: GS_ROLE) => {
  return [
    {
      id: 'purchases-module-root',
      route: 'purchases',
      allow: true,
      children: [
        {
          id: 'purchases-ticket-library',
          allow: true,
          route: 'purchases/ticket-library',
          children: [],
          displayName: 'Ticket Library',
          indeterminate: false,
        },
        {
          id: 'purchases-bills',
          allow: true,
          route: 'purchases/bills',
          children: [],
          displayName: 'Bills',
          indeterminate: false,
        },
        {
          id: 'purchases-batch-bills',
          allow: true,
          route: 'purchases/batch-bills',
          children: [],
          displayName: 'Batch Bills',
          indeterminate: false,
        },
      ],
      displayName: 'Purchases',
    },
    {
      id: 'sales-module-root',
      route: 'sales',
      allow: true,
      children: [
        {
          id: 'sales-outbound-tickets',
          allow: true,
          route: 'sales/outbound-tickets',
          children: [],
          displayName: 'Outbound Tickets',
        },
        {
          id: 'sales-invoices',
          allow: true,
          route: 'sales/invoices',
          children: [],
          displayName: 'Invoices',
        },
        {
          id: 'sales-invoice-payments',
          allow: true,
          route: 'sales/invoice-payments',
          children: [],
          displayName: 'Bulk Invoice Payments',
        },
      ],
      displayName: 'Sales',
    },
    {
      id: 'contracts-module-root',
      route: 'contracts',
      allow: true,
      children: [
        {
          id: 'contracts-sales-orders',
          allow: true,
          route: 'contracts/sales-orders',
          children: [],
          displayName: 'Sales Orders',
        },
        {
          id: 'contracts-purchase-orders',
          allow: true,
          route: 'contracts/purchase-orders',
          children: [],
          displayName: 'Purchase Orders',
        },
      ],
      displayName: 'Contracts',
    },
    {
      id: 'inventory-module-root',
      route: 'inventory',
      allow: true,
      children: [
        {
          id: 'inventory-overview',
          allow: true,
          route: 'inventory/commodities',
          displayName: 'Inventory Overview',
        },
        {
          id: 'inventory-regrades',
          allow: true,
          route: 'inventory/regrades',
          displayName: 'Regrades',
        },
        {
          id: 'inventory-finished-goods',
          allow: true,
          route: 'inventory/finished-goods',
          displayName: 'Finished Goods',
        },
        {
          id: 'inventory-packing-list',
          allow: true,
          route: 'inventory/packing-lists',
          displayName: 'Packing Lists',
        },
        {
          id: 'inventory-adjustments',
          allow: gsRole == GS_ROLE.YARD_MANAGER,
          route: 'inventory/adjustments',
          displayName: 'Adjustments',
        },
        {
          id: 'inventory-negative-inventory',
          allow: gsRole == GS_ROLE.YARD_MANAGER,
          route: 'inventory/negative-inventory',
          displayName: 'Negative Inventory',
        },
      ],
      displayName: 'Inventory',
    },
    {
      id: 'customers-module-root',
      route: 'customers',
      allow: true,
      children: [],
      displayName: 'Customers',
    },
    {
      id: 'commodities-module-root',
      route: 'commodities',
      allow: true,
      children: [
        {
          id: 'commodities-commodities-list',
          route: 'commodities/commodity-list',
          allow: true,
          children: [],
          displayName: 'Commodity List',
        },
        {
          id: 'commodities-price-lists',
          route: 'commodities/price-lists',
          allow: true,
          children: [],
          displayName: 'Price Lists',
        },
      ],
      displayName: 'Commodities',
    },
    {
      id: 'freight-module-root',
      route: 'freight',
      allow: true,
      children: [
        {
          id: 'freight-freight-lanes',
          route: 'freight/freight-lanes',
          allow: true,
          children: [],
          displayName: 'Freight Lanes',
        },
        {
          id: 'freight-freight-bills',
          route: 'freight/freight-bills',
          allow: true,
          children: [],
          displayName: 'Freight Bills',
        },
      ],
      displayName: 'Freight',
    },
    {
      id: 'load-board-module-root',
      route: 'load-board',
      allow: true,
      children: [],
      displayName: 'Load Board',
    },
    {
      id: 'assets-module-root',
      route: 'assets',
      allow: true,
      children: [],
      displayName: 'Assets',
    },
    {
      id: 'ledger-module-root',
      route: 'ledger',
      allow: true,
      children: [],
      displayName: 'Ledger',
    },
    {
      id: 'reports-module-root',
      route: 'reports',
      allow: true,
      children: [
        {
          id: 'reports-standard',
          route: 'reports/standard',
          allow: true,
          children: [],
          displayName: 'Standard Reports',
        },
        {
          id: 'reports-custom',
          route: 'reports/custom',
          allow: true,
          children: [],
          displayName: 'Custom Reports',
        },
      ],
      displayName: 'Reports',
    },
  ]
}

export const defaultAdminSettings: AdminSettings = {
  rbac: {
    [GS_ROLE.YARD_MANAGER]: getGsDefaultPolicy(GS_ROLE.YARD_MANAGER),
    [GS_ROLE.SCALE_OPERATOR]: getGsDefaultPolicy(GS_ROLE.SCALE_OPERATOR),
    [GS_ROLE.YARD_EMPLOYEE]: getGsDefaultPolicy(GS_ROLE.YARD_EMPLOYEE),
    [GS_ROLE.DRIVER]: getGsDefaultPolicy(GS_ROLE.DRIVER),
  },
}
